// extracted by mini-css-extract-plugin
export default {"wrapper":"GenericTable_wrapper__p+fIw"};